import { useEffect, useState } from "react";
import { FaWindowClose } from "react-icons/fa";
import { DetailsLive } from ".";
import VimeoComponent from "../../../components/Atoms/VimeoComponent/LiveClassVideoPlayer";
import LiveSideMenu from "../../../components/Mols/SideMenus/LiveSideMenu";
import { useAuth } from "../../../hooks/auth";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { SchoolLevel, SchoolLiveClasses } from "../../../models/SchoolModels";
import * as S from "./styles";

interface Props {
  detailsLiveOptions: DetailsLive[] | undefined;
  couseList: SchoolLiveClasses[] | undefined;
  filter: SchoolLiveClasses[] | undefined;
  handleFilter(item: any): void;
  handleIsMobileModalVideo(): any;
  isMobileModalVideo: boolean;
  isLoading: boolean;
  schoolClass: SchoolLiveClasses[] | undefined;
  schoolLevel: SchoolLevel[] | undefined;
  handleCourseClass: Function;
  handleLevelId: Function;
}

const DefaultView = ({
  detailsLiveOptions,
  couseList,
  filter,
  handleFilter,
  isLoading = false,
  schoolClass,
  schoolLevel,
  handleCourseClass,
  handleLevelId,
  isMobileModalVideo,
  handleIsMobileModalVideo,
}: Props) => {
  const [selectedPosition, setSelectedPosition] = useState(0);
  const [positionVideo, setPositionVideo] = useState(0);
  const { user } = useAuth();

  const filters: string[] = [];
  filter && filter.forEach((filter) => filters.push(filter.filter));

  const path = window.location.pathname;
  const windowDimensions = useWindowDimensions();

  // Aula com gdrive_link preenchido não tem vídeo: mostra o link no lugar do player
  const rawGdriveLink = couseList?.[positionVideo]?.gdrive_link?.trim();
  // Sem protocolo o navegador trata o link como caminho do próprio site
  const gdriveLink =
    rawGdriveLink &&
    (/^https?:\/\//i.test(rawGdriveLink)
      ? rawGdriveLink
      : `https://${rawGdriveLink.replace(/^\/+/, "")}`);

  useEffect(() => {
    if (user.profileid === "Teacher") {
      setSelectedPosition(0);
      setPositionVideo(0);
    }
  }, [path]);

  return (
    <S.Container>
      <LiveSideMenu
        firstItem={
          detailsLiveOptions && {
            key:
              detailsLiveOptions.length > 0
                ? detailsLiveOptions[0].position.toString()
                : "",
            value:
              detailsLiveOptions.length > 0 ? detailsLiveOptions[0].title : "",
          }
        }
        courseSeasonOptions={
          detailsLiveOptions &&
          detailsLiveOptions.map((option) => ({
            key: option.position.toString(),
            value: option.title,
          }))
        }
        firstFilter={{
          key: Object.keys(filters)[0],
          value: filters[0],
        }}
        filters={filters}
        onFilterChage={handleFilter}
        isLoading={isLoading}
        videos={couseList}
        onVideoChange={(item) => {
          // Encontra o índice REAL do item no array de vídeos,
          // em vez de usar classid como índice (que causa crash e thumb errada)
          const realIndex = (couseList || []).findIndex(v => v.classid === item.classid);
          const safeIndex = realIndex >= 0 ? realIndex : 0;
          setPositionVideo(safeIndex);
          setSelectedPosition(safeIndex);
          handleIsMobileModalVideo();
        }}
        selectedPosition={selectedPosition}
        schoolClass={schoolClass}
        schoolLevel={schoolLevel}
        onSeasonChange={(item) => {
          setSelectedPosition(0);
          setPositionVideo(0);
          handleCourseClass(item);
        }}
        handleLevelId={handleLevelId}
      />

      <S.StyledSeparator type="vertical" customHeight={100} />

      <S.Content>
        <S.VideoContainer
          style={
            windowDimensions && windowDimensions.width < 980
              ? {
                display: isMobileModalVideo ? "flex" : "none",
              }
              : {}
          }
        >
          {couseList && couseList.length > 0 && couseList[positionVideo] && (
            <S.OverlayVideoModal>
              <>
                <FaWindowClose
                  className="close_video"
                  onClick={handleIsMobileModalVideo}
                />
                {gdriveLink ? (
                  <S.DriveMessage>
                    <h3>O conteúdo desta aula está disponível no Google Drive.</h3>
                    <p>
                      Para acessar,{" "}
                      <a href={gdriveLink} target="_blank" rel="noreferrer">
                        Clique aqui
                      </a>
                    </p>
                  </S.DriveMessage>
                ) : (
                  <VimeoComponent url={couseList[positionVideo].url} />
                )}
              </>
            </S.OverlayVideoModal>
          )}
        </S.VideoContainer>
        <S.AnnotationsContainer hasNotes={true}>
          {couseList &&
            couseList.length > 0 &&
            couseList[positionVideo] &&
            couseList[positionVideo]?.urlfiles && (
              <>
                <h3 className="support_material">
                  <a
                    href={couseList[positionVideo]?.urlfiles}
                    target="_blank"
                    download
                  >
                    Material de Apoio
                  </a>
                </h3>
              </>
            )}
        </S.AnnotationsContainer>
      </S.Content>
    </S.Container>
  );
};

export default DefaultView;
